import React from 'react';
import get from 'lodash/get';
import { bool, object } from 'prop-types';
import Button from 'yoda-core-components/lib/components/Button';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon/next';
import IconTriangle from '../../assets/svg/Triangle.svg';
import { ctaAutomationIds, hero3BannerAutomationIds } from '../CoreMediaPage/CMPage.config';

const HeroCTA = (props) => {
    const ctaData = get(props, 'ctaLinks', []);
    const isPrimary = get(props, 'isPrimary', true);
    const styles = get(props, 'styles', {});
    const itemCtaColor = get(props, 'ctaColor', '');
    const isLink = styles?.componentCtaStyle === 'link' || props.deviceType.isMobile;
    const isDropDown =
        styles?.componentCtaStyle === 'button' && ctaData?.length > 2 && !props.deviceType.isMobile;
    const isButton =
        styles?.componentCtaStyle !== 'link' && ctaData?.length <= 2 && !props.deviceType.isMobile;

    const componentCTALinkStyle = dt([
        'flex',
        'w-auto',
        'md:last:mr-0',
        'underline',
        'md:text-xlarge',
        'md:leading-7',
        'smOnly:text-base',
        'smOnly:leading-6',
        'hover:text-black',
        'p-0',
        props.shouldScaledDownFont ? '!text-base' : '',
    ]);
    const componentCTABtnStyle = dt([
        'flex',
        'md:w-auto',
        'smOnly:w-full',
        'last:mr-0',
        'md:text-xlarge',
        'smOnly:text-base',
        'smOnly:leading-6',
        'smOnly:mb-6',
        'md:leading-7',
        'smOnly:py-[7px]',
        'md:py-[9px]',
        'px-[23px]',
        'rounded-lg',
        props.shouldScaledDownFont ? '!text-base' : '',
    ]);

    const dropbtnStyle = dt([
        'flex',
        'justify-center',
        'items-center',
        'bg-white',
        'text-black',
        props.shouldScaledDownFont ? 'text-base' : 'text-xLg',
        'border',
        'border-solid',
        'border-gray-40',
        'cursor-pointer',
        'w-60',
        'md:max-w-[248px]',
        'smOnly:w-full',
        'py-[9px]',
        'px-4',
        'rounded-lg',
        'whitespace-nowrap',
        'smOnly:mb-6',
    ]);
    const dropdownContentStyle = dt([
        'hidden',
        'absolute',
        'bg-white',
        'w-60',
        'md:max-w-[248px]',
        'smOnly:max-w-full',
        'smOnly:w-full',
        'shadow-elevation1',
        'group-hover:block',
        'text-center',
        'z-10',
        'smOnly:-mt-6',
    ]);
    const messageLockUpAlignment = get(props, 'messageLockUpAlignment', 'left').includes('left')
        ? 'left'
        : 'right';
    let rightAlignment = '';
    let leftAlignment = '';
    let rightLgAlignment = '';
    let leftLgAlignment = '';

    if (isPrimary && messageLockUpAlignment === 'right') {
        rightAlignment = 'right-6';
        rightLgAlignment = 'lg:right-10';
    } else if (messageLockUpAlignment === 'right') {
        rightAlignment = 'md:right-4';
    } else {
        rightAlignment = 'md:right-auto';
    }
    if (isPrimary && messageLockUpAlignment === 'left') {
        leftAlignment = 'left-6';
        leftLgAlignment = 'lg:left-10';
    } else if (messageLockUpAlignment === 'left') {
        leftAlignment = 'md:left-4';
    } else {
        leftAlignment = 'md:left-auto';
    }
    return (
        <div
            className={dt([
                isLink && 'smOnly:flex',
                isLink && 'smOnly:flex-wrap',
                isLink && 'smOnly:justify-center',
                isLink && 'smOnly:gap-x-4',
                isLink && 'smOnly:gap-y-4',
                isLink && 'smOnly:w-2/3',
                isLink && 'smOnly:mx-auto',
                'md:absolute',
                'bottom-4',
                'lg:bottom-[26px]',
                'md:flex',
                rightAlignment,
                rightLgAlignment,
                leftLgAlignment,
                leftAlignment,
                'md:gap-4',
            ])}
        >
            {isLink &&
                ctaData?.map((currentCta) => (
                    <Button
                        className={componentCTALinkStyle}
                        id="componentCTA"
                        aria-label={currentCta?.ctaText}
                        target={currentCta?.urlHolder?.openInNewTab ? '_blank' : ''}
                        linkUrl={currentCta?.urlHolder?.value}
                        alt={currentCta?.ctaAltText}
                        title={currentCta?.ctaAltText}
                        buttonType="Text"
                        size="Sm"
                        type="button"
                        automationId={
                            isPrimary ? ctaAutomationIds?.LINK : hero3BannerAutomationIds?.CTALINK
                        }
                        style={{ color: `#${itemCtaColor}` }}
                    >
                        {currentCta?.ctaText}
                    </Button>
                ))}
            {isDropDown && (
                <div
                    className={dt(['relative', 'inline-block', 'group', 'smOnly:w-full'])}
                    data-automation-id={
                        isPrimary ? ctaAutomationIds?.DROPDOWN : hero3BannerAutomationIds?.DROPDOWN
                    }
                >
                    <button
                        className={dropbtnStyle}
                        id="componentCTA_dropdown"
                        type="button"
                        data-automation-id={
                            isPrimary
                                ? ctaAutomationIds?.DROPDOWNBTN
                                : hero3BannerAutomationIds?.DROPDOWNBTN
                        }
                    >
                        <span className={dt(['font-open-sans-semibold', 'leading-7'])}>
                            Shop All
                        </span>
                        <Icon
                            iconType="svg"
                            className={dt(['ml-2'])}
                            width="16px"
                            height="16px"
                            viewBox="0 0 16 16"
                        >
                            <IconTriangle />
                        </Icon>
                    </button>
                    <div
                        data-automation-id={
                            isPrimary
                                ? ctaAutomationIds?.DROPDOWNITEMS
                                : hero3BannerAutomationIds?.DROPDOWNITEMS
                        }
                        className={dropdownContentStyle}
                    >
                        {ctaData?.map((currentCta) => (
                            <a
                                aria-label={currentCta?.ctaText}
                                target={currentCta?.urlHolder?.openInNewTab ? '_blank' : ''}
                                href={currentCta?.urlHolder?.value}
                                alt={currentCta?.ctaAltText}
                                title={currentCta?.ctaAltText}
                                data-automation-id={
                                    isPrimary
                                        ? ctaAutomationIds?.DROPDOWNLINK
                                        : hero3BannerAutomationIds?.DROPDOWNLINK
                                }
                                rel="noreferrer noopener"
                                className={dt([
                                    'text-black',
                                    'text-base',
                                    'py-2.5',
                                    'px-6',
                                    'no-underline',
                                    'block',
                                    'hover:bg-light-white',
                                    'whitespace-nowrap',
                                ])}
                            >
                                {currentCta?.ctaText}
                            </a>
                        ))}
                    </div>
                </div>
            )}
            {isButton &&
                ctaData?.map((currentCta) => (
                    <Button
                        className={componentCTABtnStyle}
                        aria-label={currentCta?.ctaText}
                        target={currentCta?.urlHolder?.openInNewTab ? '_blank' : ''}
                        linkUrl={currentCta?.urlHolder?.value}
                        alt={currentCta?.ctaAltText}
                        title={currentCta?.ctaAltText}
                        id="componentCTA_button"
                        automationId={
                            isPrimary ? ctaAutomationIds?.BUTTON : hero3BannerAutomationIds?.BUTTON
                        }
                        buttonType="Secondary"
                        size="Sm"
                        type="button"
                    >
                        {currentCta?.ctaText}
                    </Button>
                ))}
        </div>
    );
};

HeroCTA.defaultProps = {
    isPrimary: false,
    shouldScaledDownFont: false,
    deviceType: {},
};

HeroCTA.propTypes = {
    isPrimary: bool,
    shouldScaledDownFont: bool,
    deviceType: object,
};

export default HeroCTA;
